import { render, staticRenderFns } from "./InsightCard.vue?vue&type=template&id=057b9553&scoped=true"
import script from "./InsightCard.vue?vue&type=script&lang=ts"
export * from "./InsightCard.vue?vue&type=script&lang=ts"
import style0 from "./InsightCard.vue?vue&type=style&index=0&id=057b9553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b9553",
  null
  
)

/* custom blocks */
import block0 from "./InsightCard.vue?vue&type=custom&index=0&blockType=InsightCard&%3Ainsight=insight"
if (typeof block0 === 'function') block0(component)

export default component.exports